import React, { Component } from "react";
import SectionHeader from "../sectionHeader/sectionHeader";

class CoursesToLearn extends Component {
  constructor(props) {
    super();
    this.state = {
      phone: true,
    };
  }

  finishLoading() {
    this.setState({
      phone: false,
    });
  }

  render() {
    return (
      <section id="courses-to-learn">
        <div className="container">
          <SectionHeader
            title="Empower Your Journey to Success"
            subtitle="Unlock a World of Knowledge with "
            subtitleFinish=" Professional and Personal Development Courses!"
            greenText="Duomly's"
          />
          <div className="col col-8">
            <div className="courses-listing">
              <div className="row">
                <div className="col col-6 course-item">
                  <img
                    src={
                      process.env.PUBLIC_URL +
                      "/img/oldLanding/professional-career-courses.svg"
                    }
                    alt="Professional Career"
                  />
                  <div className="course-desc">
                    <h5>Professional Career</h5>
                    <p>
                      Gain an edge with targeted courses that deliver actionable
                      knowledge and essential skills for workplace advancement.
                      Benefit from industry insights to{" "}
                      <b>boost your employability</b> and career trajectory.
                      <br />
                      Your journey to professional distinction starts
                      here—invest in your future now!
                    </p>
                  </div>
                </div>
                <div className="col col-6 course-item">
                  <img
                    src={
                      process.env.PUBLIC_URL +
                      "/img/oldLanding/personal-development-courses.svg"
                    }
                    alt="Personal Development"
                  />
                  <div className="course-desc">
                    <h5>Personal Development</h5>
                    <p>
                      Enrich your life with essential skills that foster growth,
                      resilience, and effective communication.
                      <br />
                      Experience the benefits of{" "}
                      <b>enhanced self-awareness and productivity</b>, refining
                      both your personal and professional spheres.
                      <br />
                      Begin your transformative journey to a better you today!
                    </p>
                  </div>
                </div>
              </div>
              <div className="row">
                <div className="col col-6 course-item">
                  <img
                    src={
                      process.env.PUBLIC_URL +
                      "/img/oldLanding/entrepreneurship-courses.svg"
                    }
                    alt="Entrepreneurship"
                  />
                  <div className="course-desc">
                    <h5>Entrepreneurship & Management</h5>
                    <p>
                      Dive into the essentials of{" "}
                      <strong>
                        starting your business, mastering project leadership,
                        and people management
                      </strong>{" "}
                      with our bite-sized, interactive courses.
                      <br /> Craft your entrepreneurial story and manage with
                      confidence. Your path to business success starts here!
                    </p>
                  </div>
                </div>
                {/* <div className="col col-6 course-item">
                  <img src={process.env.PUBLIC_URL + "/img/oldLanding/react-course.svg"} alt="React Native Course" />
                  <div className="course-desc">
                    <h5><a href="https://www.duomly.com/course/react-native-course/">React Native Course</a></h5>
                    <p>React Native is a Javascript framework used to build apps for iOS and Android. It's a great way to learn mobile development for those who already know Javascript and React.js.</p>
                  </div>
                </div> */}
                <div className="col col-6 course-item">
                  <img
                    src={
                      process.env.PUBLIC_URL +
                      "/img/oldLanding/sales-courses.svg"
                    }
                    alt="Sales"
                  />
                  <div className="course-desc">
                    <h5>Sales</h5>
                    <p>
                      Our interactive courses refine your technique, from
                      mastering the <b>art of persuasion</b> to leveraging
                      cutting-edge tools like <b>ChatGPT</b>.<br /> Amplify your
                      sales impact and drive results that matter. Begin your
                      journey to sales mastery and outperform your targets!
                    </p>
                  </div>
                </div>
              </div>
              <div className="row">
                <div className="col col-6 course-item">
                  <img
                    src={
                      process.env.PUBLIC_URL +
                      "/img/oldLanding/marketing-courses.svg"
                    }
                    alt="Marketing"
                  />
                  <div className="course-desc">
                    <h5>Marketing</h5>
                    <p>
                      Tailored for modern professionals, our content arms you
                      with strategies from influencer marketing to AI-powered
                      content creation.
                      <br /> <b>Engage audiences effectively</b> and drive brand
                      success—one breakthrough campaign at a time. <br />
                    </p>
                  </div>
                </div>
                {/* <div className="col col-6 course-item">
                  <img src={process.env.PUBLIC_URL + "/img/oldLanding/blockchain-course.svg"} alt="Blockchain Course" />
                  <div className="course-desc">
                    <h5><a href="https://www.duomly.com/course/blockchain-course/">Blockchain Course</a></h5>
                    <p>In this course, you'll learn general blockchain content, from basics like what is blockchain to advanced elements like how blockchain transactions work.</p>
                  </div>
                </div> */}
                <div className="col col-6 course-item">
                  <img
                    src={
                      process.env.PUBLIC_URL +
                      "/img/oldLanding/it-ai-courses.svg"
                    }
                    alt="IT & AI"
                  />
                  <div className="course-desc">
                    <h5>IT & AI</h5>
                    <p>
                      Whether you're demystifying <b>ChatGPT & AI</b>, coding,
                      or exploring new tech trends, our interactive
                      micro-lessons equip you for the future.
                      <br />
                      <b>Build your tech skills</b> into competitive advantages
                      and become the IT expert the industry seeks.
                    </p>
                  </div>
                </div>
              </div>
            </div>
          </div>
          <div className="col col-4 col-right">
            <div className="mobile-phone">
              <img
                src={
                  process.env.PUBLIC_URL +
                  "/img/oldLanding/empower-your-journey-to-success.png"
                }
                alt="Mobile phone"
              />
            </div>
          </div>
        </div>
      </section>
    );
  }
}

export default CoursesToLearn;
